import React from 'react';
import { Box, Typography } from '@mui/material';
import { ProcessData, TimelineContainer } from 'domain/shared/timeline';
import ProcessItem from 'domain/people/employee/dashboard/summary/ProcessTimeline/components/ProcessItem';

interface ProcessTimelineComponentProps {
  processes: ProcessData[];
  loading: boolean;
  error: string | null;
  title: string;
  showProcessTitle?: boolean;
}

const ProcessTimelineComponent: React.FC<ProcessTimelineComponentProps> = ({
  processes,
  loading,
  error,
  title,
  showProcessTitle = true,
}) => {
  const renderContent = () => {
    if (loading) {
      return (
        <Box py={2} textAlign="left">
          <Typography variant="body1" color="textSecondary">
            Loading processes...
          </Typography>
        </Box>
      );
    }

    if (error) {
      return (
        <Box py={2} textAlign="center">
          <Typography variant="body1" color="error">
            {error}
          </Typography>
        </Box>
      );
    }

    if (processes.length === 0) {
      return (
        <Box py={2} textAlign="center">
          <Typography variant="body1" color="textSecondary">
            There are no active processes
          </Typography>
        </Box>
      );
    }

    return processes.map(process => (
      <ProcessItem key={process.processDefinition} process={process} showTitle={showProcessTitle} />
    ));
  };

  return (
    <TimelineContainer>
      <Typography variant="h6" color="primary">
        {title}
      </Typography>
      {renderContent()}
    </TimelineContainer>
  );
};

export default ProcessTimelineComponent;
